import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FormattedMessage, injectIntl} from 'react-intl';
import PropTypes from 'prop-types';
import Loader from '../../Loader';
import recurrentProblemMessages from '../../../intl/technicalDocumentations/recurrentProblemMessages';
import {fetchTechDocRecurrentProblems} from '../../../actions/techDoc/actionTechDocRecurrentProblem';
import RecurrentProblemTechDocRow from './RecurrentProblemTechDocRow';

class RecurrentProblemTechDocContainer extends Component {
    componentDidMount() {
        const {domain, fetchTechDocRecurrentProblems, selectedGroup} = this.props;
        fetchTechDocRecurrentProblems(domain, selectedGroup);
    }

    render() {
        const {isLoading, recurrentProblems} = this.props;
        if (isLoading) {
            return <Loader/>;
        }
        return (
            <>
                {recurrentProblems.length === 0 &&
                <div className="row">
                    <div className="col">
                        <FormattedMessage {...recurrentProblemMessages.EMPTY}/>
                    </div>
                </div>
                }
                {recurrentProblems.length > 0 &&
                <div className="row">
                    <div className="col">
                        <table className="table table-hover">
                            <thead className="thead-light">
                            <tr className="d-flex">
                                <th className="col-2">
                                    <FormattedMessage {...recurrentProblemMessages.TABLE_PROBLEM_NUMBER}/>
                                </th>
                                <th className="col-6">
                                    <FormattedMessage {...recurrentProblemMessages.TABLE_PROBLEM_TITLE}/>
                                </th>
                                <th className="col-2">
                                    <FormattedMessage {...recurrentProblemMessages.TABLE_ATTACHMENT}/>
                                </th>
                                <th className="col-2">
                                    <FormattedMessage {...recurrentProblemMessages.TABLE_LAST_UPDATE}/>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {recurrentProblems.map((recurrentProblem, index) =>
                                <RecurrentProblemTechDocRow key={`${recurrentProblem}${index}`}
                                                            recurrentProblem={recurrentProblem}
                                                            domain={this.props.domain} index={index}/>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
                }
            </>
        );
    }
}

RecurrentProblemTechDocContainer.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    recurrentProblems: PropTypes.array.isRequired,
    intl: PropTypes.any.isRequired,
    domain: PropTypes.string.isRequired,
    fetchTechDocRecurrentProblems: PropTypes.func.isRequired,
    selectedGroup: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
    isLoading: state.techDocRecurrentProblem.isLoading,
    recurrentProblems: state.techDocRecurrentProblem.recurrentProblems,
});

export default connect(mapStateToProps, {
    fetchTechDocRecurrentProblems,
})(injectIntl(RecurrentProblemTechDocContainer));
